// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"Rg-z","hidden":"Sg-z","preventTransition":"Tg-z","divBgImg":"Ug-z","loaded":"Vg-z"};